const ReconciliationChecklist = {
    id: {
        title: '账单编号',
        param: 'id',
        boxSearch: true
    },
    gmtCreate: {
        title: '创建日期',
        param: 'gmtCreate'
    },
    type: {
        title: '单据类型',
        param: 'type',
        moreSearchType: 'select',
        boxSearch: false,
        moreSearch: true,
        selectList: [
            { value: '大货', label: '大货' },
            { value: '样品', label: '样品' },
            { value: '大货·样品', label: '大货·样品' }
        ]
    },
    currencyUnit: {
        title: '币种',
        param: 'currencyUnit',
        moreSearchType: 'select',
        boxSearch: false,
        moreSearch: true,
        selectList: [
            { value: '人民币', label: '人民币'},
            { value: '美元', label: '美元' },
            { value: '欧元', label: '欧元' },
            { value: '日元', label: '日元' },
            { value: '英镑', label: '英镑' },
            { value: '港币', label: '港币' },
            { value: '法郎', label: '法郎' }
        ]
    },
    custName: {
        title: '客户名称',
        param: 'custName',
        boxSearch: true
    },
    accountName: {
        title: '抬头',
        param: 'accountName',
        boxSearch: true
    },
    totalAmount: {
        title: '账单金额',
        param: 'totalAmount'
    },
    alreadyChargeAmount: {
        title: '已收款',
        param: 'alreadyChargeAmount'
    },
    unChargeAmount: {
        title: '未收款',
        param: 'unChargeAmount'
    },
    overdueAmount: {
        title: '逾期款',
        param: 'overdueAmount'
    },
    alreadyInvoiceAmount: {
        title: '已开票',
        param: 'alreadyInvoiceAmount'
    },
    unInvoiceAmount: {
        title: '未开票',
        param: 'unInvoiceAmount'
    }
};
export default ReconciliationChecklist;
